export default [
  {
    name: 'getDepartmentHeader',
    method: 'GET',
    path: '/vue/system/departmentheader-get'
  },
  {
    name: 'getDepartmentHeaderPage',
    method: 'POST',
    path: '/vue/account/departmentheader-page'
  },
  {
    name: 'saveDepartmentHeader',
    method: 'POST',
    path: '/vue/system/departmentheader-save'
  },
  {
    name: 'deleteDepartmentHeader',
    method: 'POST',
    path: '/vue/system/departmentheader-delete'
  }
];
